module.exports = __webpack_public_path__ + "static/media/ko.0ee9cb97.png";